import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navigacija.css";
import { useTranslation } from "react-i18next";

const isMobile = () => window.innerWidth <= 768;

const Navigacija = () => {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const location = useLocation();
  const submenuRef = useRef(null);

  useEffect(() => {
    const submenuPaths = [
      "/Onas",
      "/Onas/PredsednikiKluba",
      "/Onas/CastniClani",
      "/Onas/Donacije",
      "/Onas/PostaniClan",
    ];
  
    setIsSubmenuOpen(submenuPaths.includes(location.pathname));
  }, [location.pathname]);

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsSubmenuOpen(false);
  };

  const handleNavClick = () => {
    window.scrollTo(0, 0);
    closeMenu();
  };

    // **grab the image path from your JSON**
  const helpImgSrc = t("nav.helpImage");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        submenuRef.current &&
        !submenuRef.current.contains(event.target) &&
        !event.target.closest(".submenu-trigger")
      ) {
        setIsSubmenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSubmenuHover = () => {
    if (!isMobile()) setIsSubmenuOpen(true);
  };

  const handleSubmenuLeave = () => {
    if (!isMobile()) setIsSubmenuOpen(false);
  };

  const handleSubmenuClick = (e) => {
    if (isMobile()) {
      e.preventDefault();
      setIsSubmenuOpen((prev) => !prev);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <div className="navbar">
      <div className="navbar-logo" translate="no">
        Service Above Self
      </div>
      <button
  className={`navbar-toggle ${isMenuOpen ? "active" : ""}`}
  onClick={toggleMenu}
  aria-label="Open navigation menu"
>
  <div className="bar"></div>
  <div className="bar"></div>
  <div className="bar"></div>
</button>
      {/* ...toggle button... */}
      <div className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
        <Link to="/Onas/Podstrani/Donacije" className="navbar-itemdonirajte" onClick={handleNavClick}>
              <img
            src={helpImgSrc}
            alt={t("nav.help")}
            style={{ height: "40px", objectFit: "contain" }}
          />
        </Link>
        <Link to="/" className="navbar-item" onClick={handleNavClick}>
          {t('nav.home')}
        </Link>
        <div
          className="navbar-item submenu-container"
          ref={submenuRef}
          onMouseEnter={handleSubmenuHover}
          onMouseLeave={handleSubmenuLeave}
          onClick={handleSubmenuClick}
        >
          <span className="submenu-trigger">
            <span className="navbar-item">{t('nav.about')} ↓</span>
          </span>
          {isSubmenuOpen && (
            <div className="submenu">
              <Link to="/Onas" className="submenu-item" onClick={handleNavClick}>
                {t('nav.about')}
              </Link>
              <Link to="/Onas/Podstrani/PredsednikiKluba" className="submenu-item" onClick={handleNavClick}>
                {t('nav.presidents')}
              </Link>
              <Link to="/Onas/Podstrani/CastniClani" className="submenu-item" onClick={handleNavClick}>
                {t('nav.honorary')}
              </Link>
              <Link to="/Onas/Podstrani/Donacije" className="submenu-item" onClick={handleNavClick}>
                {t('nav.donations')}
              </Link>
              <Link to="/Onas/Podstrani/PostaniClan" className="submenu-item" onClick={handleNavClick}>
                {t('nav.contactus')}
              </Link>
              <Link to="/Onas/Podstrani/Login" className="submenu-item" onClick={handleNavClick}>
                {t('nav.forMembers')}
              </Link>
            </div>
          )}
        </div>
        <Link to="/clani" className="navbar-item" onClick={handleNavClick}>
          {t('nav.members')}
        </Link>
        <Link to="/dogodki" className="navbar-item" onClick={handleNavClick}>
          {t('nav.events')}
        </Link>
        <Link to="/donatorji" className="navbar-item" onClick={handleNavClick}>
          {t('nav.donors')}
        </Link>
        <Link to="/kontakt" className="navbar-item" onClick={handleNavClick}>
          {t('nav.contact')}
        </Link>
      </div>
    </div>
  );
};

export default Navigacija;